/**
 * Utility functions for cookie management
 */

/**
 * Get a cookie value by name
 * @param {string} name - Cookie name
 * @returns {string|null} - Cookie value or null if not found
 */
export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
};

/**
 * Check if cookies are empty or if sid/user_id equals "guest"
 * @returns {boolean} - True if should logout, false otherwise
 */
export const shouldAutoLogout = () => {
  // Normalize helper
  const normalize = (value) => {
    if (typeof value !== 'string') return '';
    try {
      return decodeURIComponent(value).trim().toLowerCase();
    } catch {
      return value.trim().toLowerCase();
    }
  };

  const sidRaw = getCookie('sid');
  const userIdRaw = getCookie('user_id');
  const fullNameRaw = getCookie('full_name');

  const sid = normalize(sidRaw);
  const userId = normalize(userIdRaw);
  const fullName = normalize(fullNameRaw);

  // If ALL cookies are completely missing/empty, treat as invalid session
  // if (!sidRaw && !userIdRaw && !fullNameRaw) {
  //   return true;
  // }

  // If ANY of the key cookies is explicitly set to "guest", force logout
  if (sid === 'guest' || userId === 'guest' || fullName === 'guest') {
    return true;
  }

  return false;
};

/**
 * Get all cookies as an object
 * @returns {Object} - Object with cookie names as keys and values as values
 */
export const getAllCookies = () => {
  const cookies = {};
  if (document.cookie) {
    document.cookie.split(';').forEach(cookie => {
      const [name, value] = cookie.trim().split('=');
      if (name && value) {
        cookies[name] = decodeURIComponent(value);
      }
    });
  }
  return cookies;
};
